import { render, staticRenderFns } from "./select-tags.vue?vue&type=template&id=a9ded098&"
import script from "./select-tags.vue?vue&type=script&lang=js&"
export * from "./select-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports